import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { ButtonWithLoader } from '../ButtonWithLoader/ButtonWithLoader';
import s from './EmailCodeButton.scss';

/** "Use One Time Code Instead", under the password form's submit button. */
export const EmailCodeButton: React.FC<{
  onClick: () => void;
  dataHook: string;
  marginTop: number;
  disabled?: boolean;
  showLoader?: boolean;
  fullWidth?: boolean;
}> = ({ onClick, dataHook, marginTop, disabled, showLoader, fullWidth }) => {
  const { t } = useTranslation();
  return (
    <Box direction="vertical" width="100%" marginTop={marginTop}>
      <ButtonWithLoader
        priority="secondary"
        className={s.outlinedButton}
        onClick={onClick}
        dataHook={dataHook}
        disabled={disabled}
        showLoader={showLoader}
        fullWidth={fullWidth}
      >
        {t('signup.email_code.cta', {
          defaultValue: 'Use One Time Code Instead',
        })}
      </ButtonWithLoader>
    </Box>
  );
};
